import React from 'react'
import { observer } from 'mobx-react'
import { action, observable } from 'mobx'
import { Col } from 'react-bootstrap'
import { getTranslatedShippingMethod, i18nTranslate } from 'src/utils'
import { SHIPPING_TYPE } from 'src/utils/constant'
import {
  subscriptionContainer,
  customerContainer,
  addressContainer,
} from 'src/models'
import { toastState } from 'src/views/components'
import { ShippingDetailsCard } from './ShippingDetailsCard'
import ShippingEditingModal from './ShippingEditingModal'
@observer
class ShippingMethod extends React.Component {
  @observable isEditShippingMethod = false
  @observable modalKey = 0
  subscriptionShipping = ''
  subscriptionShippingAddressId = ''

  @action
  toggleEditSubscriptionValue = (e, id = 0) => {
    this.showEditSubscriptionModal = !this.showEditSubscriptionModal
    this.IDofCardToBeEdited = id
  }

  renderShippingMethod = (shippingMethod = {}) => {
    const {
      method = '',
      name = '',
      cost = '0',
      shippingMethodId = '',
    } = shippingMethod

    let shippingMethodAvailable = false
    if (subscriptionContainer.subscriptionPreferenceResponse?.shippingMethods) {
      shippingMethodAvailable = true
    }
    const selectedSubscription =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.subscriptions

    const currencySymbol = this.props.currencySymbol || '$'
    let description = shippingMethod?.description || ''
    const getMonthlyPV =
      subscriptionContainer.subscriptionPreferenceResponse?.order?.monthlyPV ||
      0
    const shippingCost =
      getMonthlyPV >= 100 &&
      (method.toLowerCase() == 'economy' || name.toLowerCase() == 'economy')
        ? i18nTranslate('subscription.free', 'FREE')
        : `${currencySymbol}${cost}`
    const displayDescription =
      description?.toLowerCase() != 'none'
        ? `- (${description} business days)`
        : `- ${i18nTranslate('subscription.noItemsAdded', 'No Items Added')}`

    let shippingMethodLabel =
      getTranslatedShippingMethod(shippingMethodId, false, name) || ''
    const shippingLabel = description.split(' ').join('-')
    return (
      <>
        <div
          className={`p-0 border-0 shipping-section`}
          data-testid="qa-user-sub-shipping-method">
          <Col
            className="p-0 text-dark paragraph-s"
            data-testid={`qa-user-sub-shipping-method-${shippingLabel}`}>
            {method || name ? (
              <>
                {`${shippingMethodLabel} ${cost ? shippingCost : ''}`}
                {getMonthlyPV >= 100 &&
                  (method.toLowerCase() == 'economy' ||
                    name.toLowerCase() == 'economy') && (
                    <p className="m-0 mt-2 subscription-free-shipping">
                      {i18nTranslate(
                        'subscription.freeShipping',
                        `*You've qualified for free shipping because your order
                        exceeds 100PV`
                      )}
                    </p>
                  )}
              </>
            ) : (
              <>
                {i18nTranslate(
                  'subscription.shippingMethodDescription',
                  'No Shipment This Month'
                )}
              </>
            )}
          </Col>
        </div>
      </>
    )
  }

  renderMethodDetails = () => {
    const title = i18nTranslate(
      'subscription.shippingMethod',
      'Shipping Method'
    )
    const {
      shipping,
      addresses,
      // shippingMethods = [],
    } = subscriptionContainer.subscriptionPreferenceResponse
    const shippingMethods =
      subscriptionContainer.subscriptionShippingMethods || []
    this.subscriptionShipping = shipping?.id || ''
    this.subscriptionShippingAddressId = addresses?.id || ''
    const methodName =
      getTranslatedShippingMethod(shipping?.id, false, shipping?.method) || ''
    const currencySymbol = this.props?.currencySymbol || '$'
    const methodCost = shipping?.cost
      ? `${currencySymbol}${shipping?.cost}`
      : ''
    const isShippingMethodNotAvailable = shippingMethods?.length === 0
    return (
      <div data-testid="shipping-method-container">
        <ShippingDetailsCard
          details={{
            heading: title,
            line1: methodName,
            line2: methodCost,
            event: this.handleEditShippingMethod,
          }}
          isToDisableEditButton={isShippingMethodNotAvailable}
        />
      </div>
    )
  }

  renderMethodEditDetails = () => {
    return (
      <ShippingEditingModal
        key={`shipping-modal-${this.modalKey}`}
        toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
        recommendations={subscriptionContainer.subscriptionShippingMethods}
        customModalTitle={`${i18nTranslate(
          'subscription.shippingMethod',
          'Shipping Method'
        )}`}
        selectedId={this.subscriptionShipping}
        isForShippingMethod={true}
        toggleSuggestionView={() => (this.isEditShippingMethod = false)}
        renderShippingAddressComponent={this.renderShippingMethod}
        handleAddressContinue={this.handleShippingMethodSuggestionContinue}
        selectedAddressId={this.subscriptionShippingAddressId}
        handleLimitEditShippingMethod={this.handleLimitEditShippingMethod}
      />
    )
  }

  handleShippingMethodSuggestionContinue = async (data = {}) => {
    this.isShippingMethodCallInProgress = true
    this.disableShippingEdit = true
    const {
      shippingMethodId = '',
      name = '',
      description = '',
      expectedDaysForDelivery = '',
    } = data
    const shippingData = {
      deliveryPeriod: expectedDaysForDelivery,
      shippingInstruction: description,
      shippingType: data?.properties?.BOPIS
        ? SHIPPING_TYPE.STORE_PICKUP
        : SHIPPING_TYPE.PHYSICAL,
      shippingMethod: name,
      shippingId: shippingMethodId,
    }
    if (this.selectedShippingAddressId) {
      shippingData.addressId = this.selectedShippingAddressId
    } else if (this.newAddressToUpdate?.addressId) {
      const response = await addressContainer.addProfileAddress(
        this.newAddressToUpdate,
        false
      )
      if (customerContainer.isSuccessResponse(response)) {
        shippingData.addressId = response.addressId
      } else {
        this.isShippingMethodCallInProgress = false
        return false
      }
    }
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      shippingData
    )
    this.isEditShippingMethod = false
    if (subscriptionContainer.isSuccessResponse(response)) {
      addressContainer.getProfileAddress()
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription(true))
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.shippingMethodUpdated',
          'Shipping method updated Successfully'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : response?.message ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    this.disableShippingEdit = false
    this.isShippingMethodCallInProgress = false
  }
  handleEditShippingMethod = () => {
    this.modalKey++
    this.isEditShippingMethod = true
  }

  handleLimitEditShippingMethod = () => {
    let isSelectedShippingMethodAvailable = true
    const selectedShippingId = this.subscriptionShipping

    if (subscriptionContainer.subscriptionShippingMethods?.length > 0) {
      isSelectedShippingMethodAvailable =
        subscriptionContainer.subscriptionShippingMethods.some(
          method => method.shippingMethodId === selectedShippingId
        )
    }
    return isSelectedShippingMethodAvailable
  }

  render() {
    return (
      <div className="details-section">
        {this.renderMethodDetails()}
        {(this.isEditShippingMethod || !this.handleLimitEditShippingMethod()) &&
          this.renderMethodEditDetails()}
      </div>
    )
  }
}
export default ShippingMethod
export { ShippingMethod }
